<app-table [data]="transports"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [filtersToggle]="false"
           [showFilters]="false"
           [rowExpand]="false"
           [isMaterial]="isMaterial"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'milkrun.transportation-requests.table.columns.label' | translate"
                      field="transportName">
        <ng-template #body
                     let-transport="rowData">
            {{ transport.name }}
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'milkrun.transportation-requests.table.columns.location' | translate"
                      field="atom">
        <ng-template
            #body
            let-transport="rowData">
            <div>{{ transport.location }}
                <span *ngIf="!transport.isRequest">({{ transport.plantName }})</span>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'milkrun.transportation-requests.table.columns.destination' | translate"
                      field="line">
        <ng-template #body
                     let-transport="rowData">
            <div>{{ transport.destination }}
                <span *ngIf="transport.isRequest">({{ transport.plantName }})</span>
            </div>

        </ng-template>
    </app-table-column>
    <app-table-column [header]="'milkrun.transportation-requests.table.columns.createdDate' | translate"
                      field="line">
        <ng-template #body
                     let-transport="rowData">
            <div>{{ createdDate(transport.createdDate) }}</div>
        </ng-template>
    </app-table-column>
    <app-table-column
        [header]="'milkrun.transportation-requests.table.columns.timeElapsed' | translate">
        <ng-template #body let-transport="rowData">
            <div>{{ transport.createdDate | dateAgo }}</div>
            <div class="indicator-cell"  *ngIf="hasStandardTime(transport)">
                <app-tooltip
                    *ngIf="getExceededStatus(transport) as type"
                    [type]="type"
                    displayType="tableHeader"
                    [record]="getUrgencyTooltip(transport)">
                </app-tooltip>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column cls="last-column"
                      [header]="'generic.table.columns.action' | translate"
                      field="action">
        <ng-template #body
                     let-transport="rowData">
            <app-button
                [type]="transport.load? 'primary': 'warning'"
                (click)="processTransport(transport)">{{ 'milkrun.transportation-requests.table.button' | translate }}
            </app-button>
        </ng-template>
    </app-table-column>
</app-table>
<app-transport-details-modal
    (loadToolRequest)="onLoadTransport($event)"
    (unloadToolRequest)="onUnloadTransport($event)">
</app-transport-details-modal>
